export const translations = {
    'de_DE': require('../locale/de_DE.json'),
    'en_NL': require('../locale/en_NL.json'),
    'fr_BE': require('../locale/fr_BE.json'),
    'fr_FR': require('../locale/fr_FR.json'),
    'nb_NO': require('../locale/nb_NO.json'),
    'nl_BE': require('../locale/nl_BE.json'),
    'nl_NL': require('../locale/nl_NL.json'),
    'it_IT': require('../locale/it_IT.json'),
    'es_ES': require('../locale/es_ES.json')
}